import React from 'react';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { unstable_transformConvoAI_IssueReformat } from '../../../provider/prompt-requests/transform';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { messages } from './messages';
import { isMinLength } from '../../config-item-visible/visibility-utils';
import { getSlice } from '../utils';
import { getBackendModelExperiment } from '../../utils';
import { Icon as PageIcon } from '../../assets/icons/issueReformatter';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
const SELECTION_TYPE = 'range';
function createOption({
  title,
  description,
  icon,
  getAdditionalProps
}) {
  return createEditorPluginAIConfigItemMarkdown({
    title,
    description,
    selectionType: SELECTION_TYPE,
    getInitialContext: ({
      editorView,
      positions,
      intl,
      updateIdMap
    }) => {
      const selection = sliceOrNodeToMarkdown({
        slice: getSlice(editorView, positions),
        intl,
        editorView,
        convertTo: 'markdown-plus',
        updateIdMap,
        selectionType: SELECTION_TYPE
      });
      const document = sliceOrNodeToMarkdown({
        node: editorView.state.doc,
        intl,
        editorView,
        convertTo: 'markdown-plus',
        updateIdMap,
        selectionType: SELECTION_TYPE
      });
      return {
        selection: selection.markdown,
        document: document.markdown,
        userLocale: intl.locale,
        intentSchemaId: 'issue_reformatter_intent_schema.json',
        // TODO https://jplat.jira.atlassian.cloud/browse/JNLIS-898
        contentStatistics: selection.contentStatistics
      };
    },
    triggerPromptRequest({
      initialContext,
      editorSchema
    }) {
      return unstable_transformConvoAI_IssueReformat({
        agentNamedId: 'jira_issue_reformatter_agent',
        transformationType: 'issue_reformatter',
        userLocale: initialContext.userLocale,
        editorSchema,
        currentSelection: initialContext.selection,
        // TODO https://jplat.jira.atlassian.cloud/browse/JNLIS-899
        fullDocument: initialContext.document,
        // TODO https://jplat.jira.atlassian.cloud/browse/JNLIS-899
        additionalPayload: {
          ...(getAdditionalProps === null || getAdditionalProps === void 0 ? void 0 : getAdditionalProps())
        }
      });
    },
    isVisible: ({
      editorView,
      positions
    }) => isMinLength({
      editorView,
      minLength: 1,
      positions
    }),
    icon,
    actions: [createInsertBelow({
      appearance: 'secondary'
    }), createReplace({
      appearance: 'primary'
    })],
    getBackendModel: getBackendModelExperiment,
    ...(getBooleanFF('platform.gravity.enable-the-support-for-status-labels-for-editor-ai-suggestions_em3y4') && {
      statusLozengeType: 'beta'
    })
  });
}
export const reformatWithTemplateConfigItem = options => createOption({
  title: ({
    formatMessage
  }) => formatMessage(messages.reformatWithTemplateTitle),
  description: ({
    formatMessage
  }) => formatMessage(messages.reformatWithTemplateDescription),
  icon: ({
    shownAt
  }) => /*#__PURE__*/React.createElement(PageIcon, {
    shownAt: shownAt
  }),
  getAdditionalProps: options.getAdditionalProps
});